import React, { Component } from "react";
import LayoutOperation from "../../components/layout_operation";
import { Table, Input, Select, Modal } from "antd";
import { Link } from "react-router-dom";
// import { Api } from "../../services";
import Ab from "../../services/ServiceApi";
const { Option } = Select;

const columns = [
  {
    title: "Job ID",
    dataIndex: "job_id",
    key: "job_id",
    render: (item) => (
      <Link to="/full_detail_job" className="c-blue text-underline">
        {item}
      </Link>
    ),
    sorter: (a, b) => a.job_id - b.job_id,
  },
  {
    title: "Job Category",
    dataIndex: "job_category",
    key: "job_category",
    sorter: (a, b) => a.job_category.length - b.job_category.length,
  },
  {
    title: "Area Code",
    dataIndex: "area_code",
    key: "area_code",
    sorter: (a, b) => a.area_code.length - b.area_code.length,
  },
  {
    title: "Location Name",
    dataIndex: "location_name",
    key: "location_name",
    sorter: (a, b) => a.location_name.length - b.location_name.length,
  },
  {
    title: "Inform Date",
    dataIndex: "inform_date",
    key: "inform_date",
    sorter: (a, b) => a.inform_date.length - b.inform_date.length,
  },
  {
    title: "Inform Detail",
    dataIndex: "inform_detail",
    key: "inform_detail",
    sorter: (a, b) => a.inform_detail.length - b.inform_detail.length,
  },
  {
    title: "Asset Type",
    dataIndex: "asset_type",
    key: "asset_type",
    sorter: (a, b) => a.asset_type.length - b.asset_type.length,
  },
  {
    title: "Priority",
    dataIndex: "priority",
    key: "priority",
    render: (item) => (
      <div>
        {item == "3" ? <span style={{ color: "#618817" }}>Low</span> : null}
        {item == "2" ? <span style={{ color: "#E8CD00" }}>Normal</span> : null}
        {item == "1" ? <span style={{ color: "#E09307" }}>High</span> : null}
      </div>
    ),
    sorter: (a, b) => a.total_jobs - b.total_jobs,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (item) => (
      <div>
        {item === 2 ? (
          <span className="badge badge-pill badge-light on-process font-thai-b font14">
            <span className="dot-on-process mr-2"></span>On Process
          </span>
        ) : (
          <span className="badge badge-pill badge-light font-thai-b font14">
            {item === 0 ? "Open" : null}
            {item === 1 ? "Wait Ack" : null}
            {item === 4 ? "Finish" : null}
            {item === 5 ? "Wait Approve" : null}
            {item === 7 ? "Wait Reassign" : null}
          </span>
        )}
      </div>
    ),
    sorter: (a, b) => a.total_jobs - b.total_jobs,
  },
  {
    title: "Action",
    dataIndex: "",
    key: "",
    render: (item) => (
      <Link to="/full_detail_job">
        <img src={Ab.absoluteUrl("/icon/view.svg")} />
      </Link>
    ),
  },
];

class AllJobAsset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "All Jobs Asset",
      tab: [{ text: "All Asset" }],
      active: 0,
      options: [
        { value: 1, text: "Job ID" },
        { value: 2, text: "Inform Date" },
      ],
      current_option: 1,
      data: [
        {
          job_id: 4100001,
          job_category: "Claim",
          area_code: "BKK01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          inform_date: "07/10/2020",
          inform_detail: "สาย lan เสีย",
          asset_type: "Digital MRT",
          priority: 3,
          status: 2,
        },
        {
          job_id: 4100002,
          job_category: "Claim",
          area_code: "BKK01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          inform_date: "07/10/2020",
          inform_detail: "สาย lan เสีย",
          asset_type: "Digital MRT",
          priority: 1,
          status: 5,
        },
        {
          job_id: 4100003,
          job_category: "Claim",
          area_code: "BKK01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          inform_date: "07/10/2020",
          inform_detail: "สาย lan เสีย",
          asset_type: "Digital MRT",
          priority: 3,
          status: 2,
        },
        {
          job_id: 4100004,
          job_category: "Claim",
          area_code: "BKK01",
          location_name: "ลานน้ำพุ สยามพารากอน",
          inform_date: "07/10/2020",
          inform_detail: "สาย lan เสีย",
          asset_type: "Digital MRT",
          priority: 2,
          status: 4,
        },
      ],
      visible: false,
    };
  }

  componentDidMount() {
    document.title = this.state.title;
  }

  renderModal() {
    const { visible } = this.state;
    return (
      <Modal
        title={
          <span className="font-mont-b font16 c-blue text-uppercase">
            Area Code
          </span>
        }
        centered
        visible={visible}
        footer={null}
        closable={false}
        className="custom-modal-large"
      ></Modal>
    );
  }

  render() {
    const {  data, current_option, options } = this.state;
    return (
      <LayoutOperation>
        <div className="wrapper-body" style={{ marginTop: "64px" }}>
          <div className="container-fluid">
            <h2 className="text-uppercase font-mont-b font20 c-blue">
              All Jobs Asset : 4000001
            </h2>
            <div className="my-4">
              <Input.Group compact>
                <Select
                  value={current_option}
                  style={{ width: "180px" }}
                  onChange={this.handleOptionSearch}
                >
                  {options.map((item, index) => (
                    <Option key={index} value={item.value}>
                      {item.text}
                    </Option>
                  ))}
                </Select>

                <Input.Search
                  placeholder="Search"
                  onSearch={(value) => console.log(value)}
                  style={{ width: "335px" }}
                  enterButton
                />
              </Input.Group>
            </div>
            <div className="card-table-ma">
              <div style={{ padding: "20px" }}>
                <Table rowKey="asset_id" columns={columns} dataSource={data} />
              </div>
            </div>
          </div>
        </div>
      </LayoutOperation>
    );
  }
}

export default AllJobAsset;
